import { ReactComponent as Close } from 'assets/svg/x.svg'
import { CommentTextArea } from 'components/TextInput'
import styled from 'styled-components/macro'
import { CommonPanel, PANEL_HEIGHTS } from 'theme'

export const Panel = styled(CommonPanel)<{ width?: number | undefined; innerheight?: number }>`
  position: relative;
  margin-right: 1.45vw;
  height: 100%;
  flex: 1;
  height: ${PANEL_HEIGHTS.left};

  ${({ theme, innerheight }) => theme.mediaWidth.upToExtraLarge`
    height: ${innerheight ? innerheight * 0.955 + 'px' : '96.5vh'};
    margin-right: 0.83vw;
  `};

  ${({ theme, innerheight }) => theme.mediaWidth.upToLarge`
    height: ${innerheight ? innerheight * 0.975 + 'px' : '97.5vh'};
    margin-right: 0.83vw;
  `};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    border-radius: 0px;
  `};
`

export const CloseIcon = styled.div`
  position: absolute;
  top: 1.61vh;
  right: 1.04vw;
  z-index: 1;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    top: 2.49vh;
    right: 5.38vw;
  `}
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`
export const CloseColor = styled(Close)`
  color: ${({ theme }) => theme.text4};
  width: 0.87vw;
  height: 0.87vw;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 3.85vw;
    height: 3.85vw;
  `}
`
export const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `}
`

export const ChatListPanel = styled.div`
  width: 14.58vw;
  background: ${({ theme }) => theme.bg7};
  height: 100%;
  overflow-y: auto;

  /* 滚动槽 */
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  ::-webkit-scrollbar-track {
    border-radius: 0.08vw;
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 0.08vw;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
  `}
`

export const ChatListItem = styled.div<{ actived?: boolean }>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.text4};
  cursor: pointer;
  position: relative;
  height: 8.48vh;
  width: 100%;
  background: ${({ actived }) => (actived ? '#161616' : 'transparent')};

  &:hover {
    background-color: #161616;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    height: fit-content;
    padding: 2.96vh 5.9vw 0.83vh 5.38vw;
  `}
`

export const ActivedLine = styled.div`
  width: 0.23vw;
  height: 100%;
  background: ${({ theme }) => theme.primary1};
`

export const ListItemAvatar = styled.img<{ actived?: boolean }>`
  width: 2.95vh;
  height: 2.95vh;
  border-radius: 50%;
  object-fit: cover;
  margin-left: ${({ actived }) => (actived ? '1.62vw' : '1.85vw')};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 3.91vh;
    height: 3.91vh;
  `}
`

export const ItemInfoPanel = styled.div`
  margin-left: 0.52vw;
  flex: 1;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 2.31vw;
  `}
`

export const LastMessagePanel = styled.div`
  display: none;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: flex;
    font-style: normal;
    font-weight: 300;
    font-size: 1.66vh;
    line-height: 2.13vh;

    display: flex;
    align-items: center;

    color: rgba(222, 222, 222, 0.66);
  `}
`

export const NotifyIcon = styled.div`
  width: 0.89vh;
  height: 0.89vh;
  border-radius: 50%;
  background: ${({ theme }) => theme.primary1};
  margin-right: 0.69vw;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-right: 0px;
    width: 1.18vh;
    height: 1.18vh;
  `}
`

export const ChatContentPanel = styled.div`
  flex: 1;
  height: 100%;
`

export const MessagesPanel = styled.div``

export const MessagesContent = styled.div`
  position: relative;
  overflow-y: auto;

  margin-top: 4.82vh;
  height: 83.18vh;

  /* 滚动槽 */
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  ::-webkit-scrollbar-track {
    border-radius: 0.08vw;
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 0.08vw;
  }
`

export const InputPanel = styled.div`
  display: flex;
  width: 100%;
`

export const InputImagePanel = styled.div`
  background: #222222;
  width: 2.95vh;
  height: 2.95vh;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 1.85vw;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
`

export const InputImage = styled.img`
  width: 1.61vh;
  height: 1.61vh;
`

export const CommentInput = styled(CommentTextArea)`
  flex: 1;
  display: flex;
  width: auto;
  align-items: center;
  background: rgba(222, 222, 222, 0.06);
  justify-content: center;

  width: auto;
  align-items: center;
  justify-content: center;
  overflow: auto;
  caret-color: #2142ff;

  max-height: 11.28vh;
  padding: 0.63vh 0.75vw;
  margin-left: 0.52vw;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 8.46vw;
    padding: 0.83vh 3.08vw;
    border-radius: 1.95vh;
    background: ${theme.bg7};
    max-height: 24.64vh;
    color: ${({ theme }) => theme.text4};
  `}

  textarea {
    background-color: transparent;
    caret-color: #2142ff;
    ::placeholder {
      color: rgba(222, 222, 222, 0.22);
    }
  }

  /* 滚动槽 */
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  ::-webkit-scrollbar-track {
    border-radius: 0.08vw;
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 0.08vw;
  }
`

export const SendButton = styled.div<{ disabled: boolean }>`
  display: block;
  cursor: pointer;
  font-style: normal;
  font-weight: 300;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25vh;
  line-height: 1.43vh;
  margin-left: 2.08vw;
  border-radius: 1.525vh;
  padding: 0.81vh 0.75vw;
  height: fit-content;

  margin-right: 1.85vw;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 1.66vh;
    line-height: 1.9vh;

    margin-right: 8.21vw;
    margin-left: 1.03vw;
    border-radius: 1.9vh;
    padding: 0.95vh 4.36vw;
  `}
  color: ${({ disabled, theme }) => (disabled ? 'rgba(222, 222, 222, 0.22)' : theme.text4)};
  background: ${({ disabled, theme }) => (disabled ? '#232323' : theme.primary1)};
`

export const MessagePanel = styled.div``

export const Message = styled.div`
  display: flex;
  flex-direction: column;
`

export const OwnerMessage = styled(Message)`
  flex-direction: row-reverse;
  display: flex;
  justify-content: flex-start;
`

export const MessageHeaderPanel = styled.div`
  display: flex;
  margin-left: 1.85vw;
  align-items: center;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 3.33vw;
  `}
`

export const OwnerHeaderPanel = styled(MessageHeaderPanel)`
  margin-bottom: 1.07vh;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-bottom: 0;
  `}
`

export const MessageAvatar = styled.img`
  width: 2.95vh;
  height: 2.95vh;
  border-radius: 50%;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 3.91vh;
    height: 3.91vh;
  `}
`

export const MessageName = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 1.25vh;
  line-height: 1.43vh;
  margin-left: 0.52vw;
  margin-right: 0.52vw;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 1.66vh;
    line-height: 1.9vh;
    margin-left: 2.31vw;
    margin-right: 2.31vw;
  `}

  color: ${({ theme }) => theme.text4};
`

export const MessageTime = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 1.07vh;
  line-height: 1.25vh;
  display: flex;
  align-items: center;

  margin-right: 1.85vw;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 1.42vh;
    line-height: 1.66vh;
    margin-right: 3.33vw;
  `}

  color: rgba(222, 222, 222, 0.22);
`

export const MessageContent = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 1.25vh;
  line-height: 1.61vh;

  display: flex;
  align-items: center;
  margin-left: 4.28vw;
  margin-bottom: 1.07vh;
  width: fit-content;
  max-width: 29.51vw;
  color: rgba(222, 222, 222, 0.8);
  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 1.66vh;
    line-height: 2.13vh;
    margin-left: 14.1vw;
    margin-bottom: 0;
    max-width: 67.18vw;
  `}

  p {
    white-space: pre-line;
    padding: 1.07vh 0.69vw;
    background: rgba(222, 222, 222, 0.06);
    border-radius: 0.71vh;
    ${({ theme }) => theme.mediaWidth.upToSmall`
      padding: 1.42vh 3.08vw;
      border-radius: 0.95vh;
    `}
  }
`

export const OwnerPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const OwnerMessageContent = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 1.25vh;
  line-height: 1.61vh;
  margin-bottom: 1.07vh;
  width: fit-content;
  max-width: 29.51vw;
  margin-right: 1.85vw;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 1.66vh;
    line-height: 2.13vh;
    margin-right: 3.33vw;
    margin-bottom: 0;
    max-width: 67.18vw;
  `}

  color: rgba(222, 222, 222, 0.8);
  p {
    white-space: pre-line;
    padding: 1.07vh 0.69vw;
    background: ${({ theme }) => theme.primary1};
    border-radius: 0.71vh;
    ${({ theme }) => theme.mediaWidth.upToSmall`
      padding: 1.42vh 3.08vw;
      border-radius: 0.95vh;
    `}
  }
`

export const MessageImage = styled.img`
  max-height: 28.84vh;
  max-width: 12.79vw;
  border-radius: 5px;
  border: 1px solid;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-height: 38.27vh;
    max-width: 56.67vw;
    margin-bottom: 1.42vh;
  `}
`

export const MobileContent = styled.div`
  display: none;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    height: 100%;
    display: flex;
    flex-direction: column;
  `}
`

export const MobileTitle = styled.div`
  background: #161616;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  font-style: normal;
  font-weight: 300;
  font-size: 2.49vh;
  line-height: 2.96vh;
  padding: 1.66vh 5.38vw 1.78vh 5.38vw;

  color: ${({ theme }) => theme.text4};
`
